import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useI18n } from '../../../i18n';
import { CountUp, useCommunityCount } from './loginShared';

/*
 * Row of real numbers above the final CTA. Counts must come from public
 * documents because aggregate queries are blocked for unauthenticated users.
 */
export default function StatsStrip() {
  const { t } = useI18n();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const userCount = useCommunityCount();

  const stats = [
    {
      value: inView && userCount != null ? <><CountUp value={userCount + 200} />+</> : '200+',
      label: t('kierowców w społeczności'),
    },
    { value: '5', label: t('języków aplikacji') },
    { value: '0 zł', label: t('za start i korzystanie') },
  ];

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ amount: 0.5 }}
      transition={{ duration: 0.6, delay: 0.15 }}
      className="flex items-stretch justify-center mt-10"
    >
      {stats.map((stat, i) => (
        <div
          key={i}
          className="flex flex-col items-center px-8"
          style={i > 0 ? { borderLeft: '1px solid var(--glass-border)' } : undefined}
        >
          <span className="font-mono text-3xl font-black tabular-nums" style={{ color: 'var(--text-primary)' }}>
            {stat.value}
          </span>
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] mt-1.5" style={{ color: 'var(--text-muted)' }}>
            {stat.label}
          </span>
        </div>
      ))}
    </motion.div>
  );
}
